export const COMPANY_NAME = "NPR Digital Partner";

export const PREVIOUS_VERSION = "1.3.2.5";
export const CURRENT_VERSION = "1.3.3";